<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_taxPersonStatistics"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="fetchData">查询</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="handleSort"
    >
      <vxe-table-column type="checkbox" width="60" />
      <vxe-table-column field="nsrsbh" title="纳税人识别号" min-width="150" sortable />
      <vxe-table-column field="nsrmc" title="纳税人名称" min-width="200" sortable />
      <vxe-table-column field="sbrq" title="申报日期" min-width="150" sortable />
      <vxe-table-column field="skssqq" title="税款所属期起" min-width="150" sortable />
      <vxe-table-column field="skssqz" title="税款所属期止" min-width="150" sortable />
      <vxe-table-column field="sl" title="税率" min-width="100" sortable />
      <vxe-table-column field="sbrs" title="申报人数" min-width="100" sortable />
      <vxe-table-column field="yssr" title="应税收入" min-width="150" sortable />
      <vxe-table-column field="ynse" title="应纳税额" min-width="150" sortable />
      <vxe-table-column field="ljyjnse" title="累计应缴纳税额" min-width="150" sortable />
      <vxe-table-column field="bqybtse" title="本期应补退税额" min-width="150" sortable />
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="pagination.pageNum"
      :page-size.sync="pagination.pageSize"
      :total="pagination.total"
      :page-sizes="[10, 20, 50, 100]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import {personStatistic, taxShipperTax} from "@/api/Taxation"; // API call to fetch data
export default {
  name: "TaxPersonStatistics",
  data() {
    return {
      tableData: [],
      loading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      sortConfig: {
        sortField: "",
        sortType: "",
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      const params = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        sortField: this.sortConfig.sortField,
        sortType: this.sortConfig.sortType,
      };
      const response = await personStatistic(params);
      this.tableData = response.data.records;
      this.pagination.total = response.data.total;
      this.loading = false;
    },
    handlePageChange({ currentPage, pageSize }) {
      this.pagination.pageNum = currentPage;
      this.pagination.pageSize = pageSize;
      this.fetchData();
    },
    handleSort({ column, property, order }) {
      this.sortConfig.sortField = property;
      this.sortConfig.sortType = order;
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.containerTable {
  padding: 20px;
}
</style>
